<template>
  <div class="page" v-wechat-title="$route.meta.title">

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>

    <!--视频播放弹窗-->
    <div class="video-tost" v-if="videoList1 && videoList1.length && bagInfo && bagInfo.id">
      <video class="video" preload="auto" id="videoVont" :poster="videoList1[currVideoInd].headimg" :src="videoList1[currVideoInd].url"
             x5-playsinline="" playsinline webkit-playsinline="true" page-gesture="true" show-fullscreen-btn="false"
             show-center-play-btn="true" show-play-btn="false" enable-play-gesture="true" x5-video-player-fullscreen="false"
             x-webkit-airplay="allow" x5-video-orientation="portrait"
             loop="loop" v-if="system==0">你的浏览器不支持HTML5播放此视频
      </video>
      <video class="video" preload="auto" id="videoVont" :poster="videoList1[currVideoInd].headimg" :src="videoList1[currVideoInd].url"
             x5-video-player-type="h5-page" show-fullscreen-btn="false"
             loop="loop" v-if="system==1">你的浏览器不支持HTML5播放此视频
      </video>
    </div>
    <swiper class="swiper-play" :options="swiperOption" ref="mySwiper" v-if="videoList1 && videoList1.length && bagInfo && bagInfo.id">
      <div class="swiper-slide" v-for="(item,index) in videoList1" :key="item.id" v-if="item.type>0">
        <!--<video class="video" preload="auto" :id="'video'+index" :data-id="item.id" :poster="item.headimg" :src="item.url"-->
               <!--x5-playsinline="" playsinline webkit-playsinline="true" page-gesture="true" show-fullscreen-btn="false"-->
               <!--show-center-play-btn="true" show-play-btn="false" enable-play-gesture="true" x5-video-player-fullscreen="false"-->
               <!--x-webkit-airplay="allow" x5-video-orientation="portrait"-->
               <!--loop="loop" v-if="system==0">你的浏览器不支持HTML5播放此视频-->
        <!--</video>-->
        <!--<video class="video" preload="auto" :id="'video'+index" :data-id="item.id" :poster="item.headimg" :src="item.url"-->
               <!--x5-video-player-type="h5-page" show-fullscreen-btn="false"-->
               <!--loop="loop" v-if="system==1">你的浏览器不支持HTML5播放此视频-->
        <!--</video>-->
        <!--<img class="video-img" :src="item.headimg" alt="" v-if="currVideoInd==index&&!playing">-->

        <p class="play" @click.stop="playVideo(index)"><img src="../../assets/city_icon_play01.png" alt="" v-if="currVideoInd==index&&!playing"></p>

        <div class="title">
          <h3 class="">
            <span class="tit-img" @click.stop="goGuideInfo(id)"><img class="img" v-lazy="bagInfo.tvideourl" alt=""></span>
            <span class="tit-txt">{{item.name}}</span>
            <span class="title-label" v-if="bagInfo&&bagInfo.sellprice!=0&&bagInfo.isbuy!=1&&index>2">付费收看</span>
          </h3>
          <p class="tit-dec">{{item.info}}</p>
        </div>

        <!--右下角点赞评论数据-->
        <div class="num-box">
          <span class="block tc ds" @click.stop="rewardShowFun" v-if="res.noReward!=1"><img src="../../assets/video_icon04.png" alt="">{{bagInfo.dsnum|initNumber}}</span>
          <span class="block tc" @click.stop="videoZan(index,item.id)"><img :src="item.iszan==1?require('../../assets/video_icon01_hover.png'):require('../../assets/video_icon01.png')" alt="">{{item.zan|initNumber}}</span>
          <span class="block tc" @click.stop="showComments(item.id),videoCommentShow=1"><img src="../../assets/video_icon02.png" alt="">{{item.comment|initNumber}}</span>
          <!--<span class="block tc" @click.stop="shareTip=1"><img src="../../assets/video_icon03.png" alt="">{{bagInfo.share|initNumber}}</span>-->
          <span class="block tc" @click.stop="outerBoxPos=0"><img src="../../assets/video_icon05.png" alt="">线路</span>
        </div>
      </div>
    </swiper>

    <!--评论弹窗-->
    <div class="alert-box" v-if="videoCommentShow==1" @click.stop="videoCommentShow=0,videoCommentBtn=0">
      <div class="video-comments">
        <p class="video-comment-num">{{commentTotal}}条评论</p>
        <img class="video-comment-close" src="../../assets/icon-close.png" alt="" @click.stop="videoCommentShow=0">
        <ul class="video-comment-ul">
          <li class="video-comment-li box" v-for="(item,index) in commentList" :key="index" v-if="commentTotal>0">
            <img class="video-comment-img flex" :src="item.headimg" alt="">
            <div class="video-comment-info flex">
              <div class="video-comment-name hide">{{item.name}}</div>
              <div class="video-comment-con">{{item.content}} <span>{{item.time}}</span></div>
            </div>
          </li>
          <p class="load-tip" v-else>暂无评论</p>
        </ul>
        <div class="mask" :class="videoCommentBtn==1?'':'none'" @click.stop="videoCommentBtn=0"></div>
        <div class="video-comment-btn" :class="videoCommentBtn==1?'curr':''">
          <input class="border-box" placeholder="留下你的精彩评论吧" type="text" v-model="commentInfo" @click.stop="videoCommentBtn=1">
          <button @click.stop="videoComment">发送</button>
        </div>
      </div>
    </div>

    <!--专辑线路-->
    <!--<div class="voice-list border-box"-->
         <!--:class="[outerBoxPos===0?'pullUp0':outerBoxPos===1?'pullUp1':outerBoxPos===2?'pullUp2':outerBoxPos===3?'pullUp3':'',bagInfo&&bagInfo.shopType=='buddhism'?'sm':'']"-->
         <!--ref="outerBox" v-swipeup.stop="swipeup1" v-swipedown.stop="swipedown1" @click.stop="outerBoxPos='pullUp3'">-->
    <div class="voice-list border-box"
         :class="[outerBoxPos===0?'pullUp0':outerBoxPos===1?'pullUp1':outerBoxPos===2?'pullUp2':outerBoxPos===3?'pullUp3':'',bagInfo&&bagInfo.shopType=='buddhism'?'sm':'']"
         ref="outerBox" @click.stop="outerBoxPos='pullUp3'">
      <span class="pull-btn"></span>
      <img class="pull-close" src="../../assets/focus-close.png" alt="" @click="closePull">
      <div class="voice-list-box">
        <div class="voice-list-top border-box" v-if="bagInfo && bagInfo.id">
          <div class="video-card border-box box">
            <p class="video-card-img"><img class="img" :src="bagInfo.tvideourl" alt=""></p>
            <div class="flex video-card-info">
              <h3 class="hide">{{bagInfo.name}}</h3>
              <div class="label hide">
                <span>{{bagInfo.guidename}}</span>
                <span v-if="bagInfo.label">{{bagInfo.label}}</span>
              </div>
              <p class="hide">{{bagInfo.play|initNumber}}播放 |  {{zanToatal|initNumber}}点赞</p>
            </div>
          </div>

          <div class="voice-bar border-box" v-if="bagInfo.sellprice==0||bagInfo.isbuy>0">
            <!--<span class="fl span01" @click.stop="videoPlayZan()" :class="res.iszan==1?'curr':''"></span>-->
            <span class="fl span02" @click.stop="shareTip=1"></span>
            <span class="fl span03" @click.stop="showComments1()"></span>
            <p class="fr" @click.stop="rewardShowFun" v-if="res.noReward!=1">打赏5元</p>
          </div>
          <div class="voice-bar border-box" v-else>
            <p class="fl">付费解锁{{videoList1.length}}个讲解视频</p>
            <div class="fr active border-box"  @click.stop="buyVideo()">￥{{bagInfo.sellprice}} <p><span>限时优惠</span><b>￥{{bagInfo.sellprice+2}}</b></p></div>
          </div>
        </div>
        <!--<div class="voice-list-ul border-box"  @scroll="scrollEvent" v-swipeup.stop="swipeup2" v-swipedown.stop="swipedown2">-->
        <div class="voice-list-ul border-box" >
          <div class="voice-scoll border-box" id="voice-scoll">
            <div v-if="videoListNew && videoListNew.length>0">
              <div class="route-box" :style="{height:routeH+ 'px'}" v-for="(item,index) in videoListNew" :key="index">
                <div class="route-li" :class="['route-li-0'+parseInt(ind+1),ite.type>0?'route-li-img':'route-li-name',ite.id==videoList1[currVideoInd].id?'curr':'']"
                     v-for="(ite,ind) in item" :key="ite.id" :data-id="ite.id">
                  <p class="image" v-if="ite.type>0" @click.stop="showVideoAlert(ite.id)"><img class="img" v-lazy="ite.headimg" alt=""></p>
                  <p class="txt" :class="'txtlen' + (ite.name).length" v-else>{{ite.name}}</p>
                  <p class="name hide2" v-if="ite.type>0">{{ite.name}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--新版本打赏弹窗8-20-->
    <AlertReward :bagInfo="bagInfo" :res="res" :that="that" :dsImgs="res.dsimgs" @child-Reward="closeReward" v-if="rewardShow==1"></AlertReward>
    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="'2'" :price="bagInfo.sellprice" :buybtn="buyVideo" v-if="buyTip==1"></AlertPayTip>

    <!--提示分享弹窗-->
    <div class="system-alert" v-show="shareTip==1">
      <img class="system-img" src="../../assets/a_07.png" alt="">
      <div class="system-btn" @click="shareTip=0">知道了</div>
    </div>

  </div>
</template>

<script>

  import {uploadUserBrowse,getVideoSpots,getVideoInfo,getVideoList,videoZan,videoCount,videoComments,videoComment,videoReply,citySiteFoodZan} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertReward from '../../components/AlertReward'
  import AlertPayTip from '../../components/AlertPayTip'
  import P400 from '../../components/P400'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import vueTouch from "@/config/vueTouch";
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  var fromPath,fullPath;
  var VM = null,
    activeIndex = 0; //当前要播放的视频下标
  export default {
    data(){
      return {
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',

        id: this.$route.query.id || '', //视频专辑id
        shopid: this.$route.query.shopid || '', //景区id
        userInfo: {}, //用户信息
        sregion: '', //省站点id:430000
        siteid: '', //站点id
        res:{
          isReward: false,  //未打赏过  true已打赏过
          noReward: 1 // 0自愿打赏 1关闭打赏 2强制打赏
        },//接口所有数据
        inputValue: '',//搜索关键词
        bagInfo: null, //视频专辑信息
        orderby: 'tui', //视频列表排序  tui（默认）-推荐 zan-点赞 play-播放量
        videoList: [], //视频列表数据
        videoList1: [], //视频列表数据（只存储video数据）
        videoListNew: [], //处理后的视频列表数据
        zanToatal: 0, //总共的点赞数

        buyTip: 0, //购买提醒弹窗
        catalogueCurr: 0,
        catalogueRoot: [],//目录弹窗内容

        shareTip:0,//分享提示弹窗
        rewardShow:0,//打赏弹窗

        videoCommentShow: 0, //视频评论弹窗 0:不显示 1:显示
        videoCommentBtn:0,//0：评论关闭 1：评论开启
        currVideoInd: 0, //当前正在播放的视频下标
        playing: false, //true：在播放 false:没有播放
        commentInfo: '',//评论内容
        commentList: [], //评论列表
        commentTotal: 0, //评论总数

        P400: 0, //系统维护中


        system:'',//0：ios 1:android
        swiperOption: {
          pagination: false,
          autoplayDisableOnInteraction: false,
          autoplay: false,
          effect: 'slide',
          direction: 'vertical', // 垂直切换选项
          loop: false,
          initialSlide: this.$route.query.ind || 0, //从哪一个开始

          observeParents:true,
          observer: true,
          preventClicksPropagation: true,//阻止click冒泡。拖动Swiper时阻止click事件。
          simulateTouch: false,//鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
          on: {
            init: function(){
              VM.load = 'init';
              activeIndex = this.activeIndex;
              VM.currVideoInd = activeIndex;
            },
            transitionEnd: function(){
              activeIndex = this.activeIndex;
              if(activeIndex <3 || VM.bagInfo.isbuy || VM.bagInfo.isguide || VM.bagInfo.sellprice ==0){
                var videoCurr = document.getElementById("videoVont");
                videoCurr.src = VM.videoList1[activeIndex].url;

                setTimeout(function(){
                  videoCurr.play();
                },150);

                VM.currVideoInd = activeIndex;
                VM.playing = true;
                VM.videoCount(VM.videoList1[activeIndex].id,'play')

                if(videoCurr.readyState != 4){
                  VM.$loading.show('视频加载中');
                }
                VM.videoTimeupdate(videoCurr);
              }else {
                VM.outerBoxPos = 0;
              }


            }
          }
        },

        routeH: 0, //线路模块的高度
        outerBoxPos: 0, //线路弹窗当前位置 0: 底部->中间  1：中间->顶部   2：顶部->中间  3:中间->底部  4: 没有
        scrollTop: 0, //  滑动到值为0的时候，记录
        scrollTopNum: 1, //  第一次滑动到值为0的时候，记录
      }
    },
    created(){
      VM = this;
      this.that = this;
      this.userInfo = getStore("userInfo");

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.action = this.$route.query.action;
      if(this.action == "cancel"){
        let self = this;
        this.$confirm({
          title: '提示',
          content: '取消推送授权，退出后将找不到页面入口，需要重新授权吗？',
          component: wxConfirm
        }).then(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-list?id='+self.id+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        }).catch(function(res){
          if(res == 'success') {
            pushOrder('dist/index.html#/video-list?id='+self.id+'&shopid='+ self.shopid + '&TimeStamp='+ self.TimeStamp + '&appKey='+ (self.appKey));
          }
        })
      }

      this.$loading.show('数据加载中');

      this.getVideoInfo();
      this.getVideoList(this.orderby);
      this.downApp();

      window.addEventListener("scroll",function(){})
    },
    beforeDestroy(){
      var videoCurr = document.getElementById("video" + activeIndex);
      if(videoCurr && !videoCurr.paused){
        videoCurr.pause();
        this.playing = false;
      }
    },
    beforeRouteEnter (to, from, next) {
      if(from.path.indexOf('video-list') > -1){
        fromPath = 'video-list';
        fullPath = to.fullPath;
      }
      next();
    },
    mounted(){
      if(fromPath == 'video-list'){
        this.$router.replace({
          path: fullPath
        });
      }
      if(this.form == 'pay'){
        window.addEventListener("popstate", function(e) {
          window.history.go(-6);
        }, false);
        pushHistory();
        function pushHistory() {
          var state = {
            title: "title",
            url: ""
          };
          window.history.pushState(state, "title", "");
        }
      }
      document.addEventListener('touchmove', function(e) {
        e.preventDefault();
      }, false);
    },
    methods: {

      //判断手机系统
      downApp() {
        let ua = navigator.userAgent.toLowerCase();
        //Android终端
        let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
        //Ios终端
        let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //Ios
          this.system = 0;
        } else if (/(Android)/i.test(navigator.userAgent)) {
          //Android终端
          this.system = 1;
        }
      },

      //获取视频专辑信息
      async getVideoInfo(){
        let res = await getVideoInfo({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: this.id
        });
        if (res.errcode === "00000"){
          this.$loading.hide();
          this.bagInfo = res.data;
          this.bagInfo.guideheadimg2 = res.data.headimg;
          this.bagInfo.guidename2 = res.data.guidename;
          this.res = res.data;

          this.$route.meta.title = this.bagInfo.name;

          var title = '金牌解说 | 视频解说';
          var desc = '我是'+ this.bagInfo.guidename +'，我在“金牌解说”为您讲解'+ this.bagInfo.name;
          var img = this.bagInfo.tvideourl;
          var link = '/video-list?id='+ this.id +'&ind='+ this.currVideoInd +'&shopid='+ this.shopid +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          wxShareme(title,desc,img,link,function(){
            VM.videoCount(VM.videoList1[activeIndex].id,'share')
          });

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }
      },

      //获取视频数据
      async getVideoList(orderby){
        let res = await getVideoList({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id,
          orderby: orderby
        });
        if(res.errcode == '00000'){
          if(res.data.data != null && res.data.data.length > 0){
            var data = res.data.data;
            this.videoList = data;
            if(data && data.length>0){
              this.setRouteH();
              for(var i=0;i<data.length;i+=6){
                this.videoListNew.push(data.slice(i,i+6));
              }
              for(var i=0; i<data.length; i++){
                if(data[i].type > 0){
                  this.zanToatal += data[i].zan;
                  this.videoList1.push(data[i])
                }
              }

              if(this.$route.query.ind){
                activeIndex = this.$route.query.ind;
                this.currVideoInd = this.$route.query.ind;
                this.swiperOption.initialSlide = this.$route.query.ind;
              }


              /*
              setTimeout(function(){
                if(VM.outerBoxPos === 2 || VM.outerBoxPos === 0){
                  VM.outerBoxPos = 3;
                }else {
                  VM.outerBoxPos = ""
                }
              },3500);
              */

            }
          }
        }
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //专辑点赞
      async videoPlayZan(){
        let res = await citySiteFoodZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          bagid: this.id
        });
        if(res.errcode == "00000"){
          this.bagInfo.zancounts++;
          this.res.iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },

      //打赏弹窗显示隐藏
      rewardShowFun(){
        this.rewardShow = 1;
      },
      //打赏弹窗隐藏
      closeReward :function(msg){
        this.rewardShow = msg.rewardShow;
        if(msg.success){
          this.bagInfo.dsnum++;
        }
      },

      //跳转到导游详情页
      goGuideInfo(id){
        if(this.shopid=='702' || this.shopid=='1009' || this.shopid=='1138'){

        }else {
          this.$router.push({
            path: `/guide-info?${'id='+ id + '&typeList=1&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }

      },

      //拿到数组中指定id的下标
      getIndex(arr,id){
        let result;
        if(arr.find(function(x) {return x.id == id;}) != undefined) {
          arr.find(function(x,i) {
            if(x.id == id){
              result =  i;
            }
          });
          return result;
        }else {
          return 0;
        }
      },

      //播放指定视频
      showVideoAlert(id){
        var ind = this.getIndex(this.videoList1,id);

        if(ind <3 || this.bagInfo.isbuy || this.bagInfo.isguide || VM.bagInfo.sellprice ==0){
          var videoCurr = document.getElementById("videoVont");
//          var videoCurr = document.getElementById("video" + ind);
          videoCurr.play();
          this.$refs.mySwiper.swiper.slideTo(ind, 1000, true)
          if(this.outerBoxPos === 2 || this.outerBoxPos === 0){
            this.outerBoxPos = 3;
          }else {
            this.outerBoxPos = ""
          }
        }else {
          this.$toast('付费解锁全部讲解视频')
        }
      },

      //播放视频
      playVideo(ind,type){
        if(ind <3 || this.bagInfo.isbuy || this.bagInfo.isguide || VM.bagInfo.sellprice ==0){
          var videoCurr = document.getElementById("videoVont");
//          var videoCurr = document.getElementById("video" + ind);
          if(type || videoCurr.paused){
            videoCurr.play();
            this.currVideoInd = ind;
            this.playing = true;

            if(videoCurr.readyState != 4){
              this.$loading.show('视频加载中');
            }
            this.videoTimeupdate(videoCurr);
          }else {
            videoCurr.pause();
            this.playing = false;
          }
        }else {
//          this.buyTip = 1;
          VM.outerBoxPos = 0;
        }

        if(this.videoCommentShow == 1){
          this.videoCommentShow = 0
        }
      },

      //视频分享、播放统计数据
      async videoCount(id,type){
        let res = await videoCount({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: id,
          type: type //play（默认）-播放量 share-分享
        });
        if(res.errcode == "00000"){
          if(type == 'play'){
            VM.videoList1[activeIndex].play++;
          }else if(type == 'share'){
            VM.bagInfo.share++;
          }
        }
      },

      //用户点赞
      async videoZan(ind,id){
        let res = await videoZan({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: id
        });
        if(res.errcode == "00000"){
          this.videoList1[ind].zan++;
          this.videoList1[ind].iszan = 1;
          this.$toast("点赞成功",{ location: ''})
        }else{
          this.$toast(res.errmsg,{ location: ''})
        }
      },

      //拉取评论列表
      async showComments(id){
        let res = await videoComments({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: id
        });
        if(res.errcode == "00000"){
          this.commentList = res.data.data==null?[]:res.data.data;
          this.commentTotal = res.data.total;
        }
      },
      //发送评论
      async videoComment(){
        if(this.commentInfo=='' || this.commentInfo == null){
          this.$toast('请先输入内容');
          return;
        }
        let res = await videoComment({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          id: VM.videoList1[activeIndex].id,
          content: this.commentInfo,
        });
        if(res.errcode == "00000"){
          this.videoList1[activeIndex].comment++;
          this.showComments(VM.videoList1[activeIndex].id);
          this.commentInfo = "";
          this.videoCommentBtn = 0;
        }
      },
      //打开评论
      showComments1(){
        this.showComments(VM.videoList1[activeIndex].id);
        this.commentInfo = "";
        this.videoCommentShow=1
        if(this.outerBoxPos === 2 || this.outerBoxPos === 0){
          this.outerBoxPos = 3;
        }else {
          this.outerBoxPos = ""
        }

      },

      //点击购买，调用下订单公用方法
      buyVideo(){
        let self = this;
        setStore("source", {"source": "video"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+self.bagInfo.id+'&cid=&shopid='+self.shopid+'&bagtype=4'+'&appKey='+(self.appKey)}`
        });
      },

      //计算一个线路模块的高度
      setRouteH(){
        var self = this;
        self.$nextTick(function(){
          var width = document.getElementById('voice-scoll').offsetWidth;
          self.routeH = 803*width / 629;
        })
      },

      swipeup1(e){
        if(this.outerBoxPos === 0 || this.outerBoxPos === 2){
          this.outerBoxPos = 1;
        }else if(this.outerBoxPos === 3){
          this.outerBoxPos = 0;
        }
      },

      swipedown1(e){
        if(this.outerBoxPos === 1){
          this.outerBoxPos = 2;
        }else if(this.outerBoxPos === 2 || this.outerBoxPos === 0){
          this.outerBoxPos = 3;
        }
      },

      swipeup2(){},

      swipedown2(e){
        if(this.scrollTopNum === 1){
          this.scrollTopNum++;
        }
        if(this.scrollTopNum >1){
            this.swipedown1();
        }
      },

      scrollEvent(e){
          this.scrollTop = e.srcElement.scrollTop;
          if(this.scrollTop === 0){
            this.scrollTopNum++;
          }else {
            this.scrollTopNum = 0;
          }
          if(this.scrollTop >= 250){
            this.outerBoxPos = 1;
          }
      },

      videoTimeupdate(Media){
        Media.addEventListener("timeupdate",function(){
          if(Media.readyState == 4){
            VM.$loading.hide();
          }
        },false);
      },

      closePull(){
        this.outerBoxPos='pullUp3';
        this.playVideo(activeIndex,1);
      },

    },
    watch:  {

    },
    components: {
      AlertReward,
      AlertPayTip,
        P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      strText: function (txt) {
        if(txt.length>=8){
          txt = txt.substring(0,8)+'...'
        }
        return txt;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  * { touch-action: pan-y; }
  .page{position: absolute;width: 100%;height: 100%; overflow: hidden;padding: 0;background-color: #000;-webkit-overflow-scrolling: touch; }

  .video-top{ padding: .25rem .24rem 0;
    background: -webkit-gradient(linear, top top, bottom bottom, from(#ededed) , to(#fff));
    background: -webkit-linear-gradient(top, #ededed, #fff , #fff);
    background: linear-gradient(to bottom, #ededed, #fff , #fff); }

  .video-tost{position: fixed;left: 0; top:0; right: 0; bottom:0; z-index: 1; width: 100%; height: 100%; overflow: hidden;}
  .video-tost .video{ position: relative; z-index: 1; width: 100%; height: 100%; /* object-fit: cover; */ }

  .swiper-play{ position: relative; z-index: 1; width: 100%; height: 100%; overflow: hidden;background-color: transparent; }
  .swiper-play .video{ position: relative; z-index: 1; width: 100%; height: 100%; /* object-fit: cover; */ }
  .swiper-play .video-img{ display: block; margin: 0 auto; position: relative; z-index: 1; width: auto; height: 100%; /* object-fit: cover; */ }
  .swiper-play .play{ position: absolute; left: 0; top: 0; z-index: 2; width: 100%; height: 100%; }
  .swiper-play .play img{ position: absolute; top: 50%; left: 50%; z-index: 1; margin: -.5rem 0 0 -.5rem; width: 1rem; height: 1rem; }
  .swiper-play .title{ position: absolute;z-index: 3; left: .23rem; bottom: .5rem; right: 1.9rem; color: #fff; }
  .swiper-play .title h3{ position: relative; padding-left: .65rem; }
  .swiper-play .title h3 .tit-img{ position: absolute; left: 0; top: 0; width: .56rem; height: .56rem; border-radius: 100%; overflow: hidden; }
  .swiper-play .title h3 .tit-txt{ line-height: .42rem; font-weight: normal; font-size: .3rem; }
  .swiper-play .title h3 span.title-label{ vertical-align: text-bottom; width:auto;height: .34rem;padding: 0 .08rem;margin-top:-.17rem;margin-right:0;border-radius: .05rem;font: bold .22rem/.34rem "Microsoft YaHei";color: #fff;background: #faaf39;}
  .swiper-play .title .tit-dec{ margin-top: .18rem; line-height: .42rem; font-size: .28rem; }
  .swiper-play .num-box{position: absolute;right:0;bottom:.5rem; z-index: 3; width: 1.27rem;}
  .swiper-play .num-box span{margin-top:.45rem;font-size: .28rem;color: #fff;}
  .swiper-play .num-box img{display: block;width: .6rem;height: auto;margin: 0 auto .17rem;}
  .swiper-play .num-box .ds img{ width: .7rem;}
  .swiper-play .swiper-slide img{ background-image: none; }

  .video-comments{position: absolute;left: 0;right: 0;bottom: 0;max-height: 66.4vh;padding:.3rem .3rem 1.2rem;background: #fff;border-radius: .13rem .13rem 0 0;}
  .video-comment-num{font-size: .28rem;color: #333;}
  .video-comment-close{position: absolute;top:.32rem;right: .3rem;width: .24rem;height: auto;}
  .video-comment-ul{margin-top: .27rem; height: 5.6rem; overflow-y: auto; }
  .video-comment-li{margin-top: .38rem;}
  .video-comment-img{width: .88rem;height: .88rem;margin-right:.22rem;border-radius: 50%;object-fit: cover;}
  .video-comment-name{margin-top:.1rem;font-size: .3rem;color: #666;}
  .video-comment-con{margin-top:.15rem;font: .28rem/.42rem "Microsoft YaHei";color: #333;}
  .video-comment-con span{margin-left: .12rem;color: #999;}
  .video-comment-btn{position: absolute;left: 0;right: 0;bottom: 0;height: .96rem;border-top: 1px solid #e3e3e3;border-left: 1px solid #e3e3e3;border-right: 1px solid #e3e3e3;font: .28rem/.96rem "Microsoft YaHei";color: #999;background: #fff;}
  .video-comment-btn input{position: absolute;left: 0;top: 0;right: 1.48rem;width: 78%;height: .96rem;padding:.2rem .3rem;}
  .video-comment-btn button{display:none;position: absolute;top: 0;right: 0;bottom: 0;width: 1.48rem;text-align: center;font: .36rem/.96rem "Microsoft YaHei";color: #fff;background: #f8af3c;}
  .video-comment-btn.curr button{display: block;}



  /*购买成功后提示收藏弹窗*/
  .system-alert{position: fixed;z-index: 999;top:0;left: 0;width: 100vw;height: 100vh;background: rgba(0,0,0,.9);}
  .system-img{display: block;width: 70%;height: auto;margin: .8rem auto 0;}
  .system-btn{display: block;width: 2.32rem;height: .72rem;margin:.82rem auto;border: 1px dashed #fff;font: .28rem/.72rem "Microsoft YaHei"; border-radius: .1rem;text-align: center;color: #fff;}

  /*讲解目录*/
  .sm .catalogue-item{padding: .56rem 0 1.5rem 0;background: url("../../assets/sm-shade.png") repeat;}
  .sm .catalogue-input input {font-size: .28rem;color: #999;border-bottom: 1px solid #cecece;background: none;}
  .sm .catalogue-item-con{top:2.24rem;left:0;bottom:1.5rem;border-bottom: none;}
  .sm .catalogue-line{margin-top: .25rem;background: #796042;}
  .sm .catalogue-tit{position: relative;height: .4rem;line-height: .4rem;padding: .22rem 0 .22rem.36rem;font-size: .28rem;color: #666;}
  .sm .catalogue-tit img{width:auto;height: .13rem;margin-left: .06rem;}
  .sm .catalogue-ul.curr .catalogue-tit img{-webkit-transform: rotate(180deg);transform: rotate(180deg);}
  .sm .catalogue-li-box{display:none;width: 100%;padding-left:.66rem;padding-top: .28rem;padding-bottom:.3rem;background: rgba(238,238,238,.65);}
  .sm .catalogue-ul.curr .catalogue-li-box{display: block;}
  .sm .catalogue-li{ display: block; width: 100%;line-height: .4rem;margin-right: .1rem;margin-top:.28rem;font-size: .28rem;color: #666;}
  .sm .catalogue-li:first-child{margin-top: 0;}
  .sm .catalogue-li span{line-height: .4rem;margin-right:.1rem;font-size: .28rem;color: #796042;}


  /*专辑线路*/
  .voice-list{position: fixed;left: 0;right: 0;padding: .6rem .24rem 0;;top: 100%;bottom: 0;background: #f9d6ae;z-index: 100000;  border-radius: .2rem .2rem 0 0; }
  .voice-list.pullUp0{-webkit-animation: pullUp0 .4s linear;animation: pullUp0 .4s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .voice-list.pullUp1{-webkit-animation: pullUp1 .4s linear;animation: pullUp1 .4s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .voice-list.pullUp2{-webkit-animation: pullUp2 .4s linear;animation: pullUp2 .4s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .voice-list.pullUp3{-webkit-animation: pullUp3 .4s linear;animation: pullUp3 .4s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  @-webkit-keyframes pullUp0 {from{top: 100%;}to{top:12%;}}
  @keyframes pullUp0 {from{top: 100%;}to{top:12%;}}
  @-webkit-keyframes pullUp1 {from{top: 12%;}to{top:-2.76rem;}}
  @keyframes pullUp1 {from{top: 12%;}to{top:-2.76rem;}}
  @-webkit-keyframes pullUp2 {from{top: -2.76rem;}to{top:12%;}}
  @keyframes pullUp2 {from{top: -2.76rem;}to{top:12%;}}
  @-webkit-keyframes pullUp3 {from{top: 12%;}to{top:100%;}}
  @keyframes pullUp3 {from{top: 12%;}to{top:100%;}}

  .pull-close{ display: none; position: absolute;top:-.54rem;left:50%;width: .53rem;height: .53rem;margin-left:-0.265rem; }
  .pullUp0 .pull-close{ display: block;}
  .pull-btn{position: absolute;top:.33rem;left:50%;width: 1.02rem;height: .1rem;margin-left:-0.51rem;background: #d6b895;}

  .voice-list-box{ position: relative; width: 100%; height: 100%; background: #fff url("../../assets/a_09.png") repeat; border-radius: .15rem .15rem 0 0;
    display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column;}
  .voice-list-top{position:relative;z-index:2;width: 100%;height: 3.45rem;  border-radius: .15rem .15rem 0 0; }

  .video-card{ padding: .24rem; height: 2.16rem; border-bottom: .01rem solid #e5e5e5; }
  .video-card-img{ width: 1.68rem; height: 1.68rem; border-radius: .08rem; overflow: hidden; }
  .video-card-info{ position: relative; height: 1.68rem; margin-left: .16rem; }
  .video-card-info h3{ font-size: .36rem; line-height: .6rem; color: #333; }
  .video-card-info .label span{ display: inline-block; padding: 0 .1rem; height: .4rem; line-height: .4rem; font-size: .24rem; color: #666; background-color: rgba(0,0,0,.14); border-radius: .06rem; }
  .video-card-info p{ position: absolute; left: 0; bottom: .09rem; font-size: .26rem; color: #999; }

  .voice-bar{ position: relative; margin-left: -.24rem; margin-right: -.24rem; padding: .25rem .48rem; height: 1.3rem; background-color: #fff;box-shadow: 0 .05rem .09rem #d8dadf; }
  .voice-bar:before{ position: absolute; content: ''; left: -0.36rem; bottom: -.3rem; width: 0; height: 0; z-index: -1;border: .3rem solid; border-color: transparent #e9c194 transparent transparent; }
  .voice-bar:after{ position: absolute; content: ''; right: -0.36rem; bottom: -.3rem; width: 0; height: 0; z-index: -1;border: .3rem solid; border-color: transparent transparent transparent #e9c194; }
  .voice-bar span.fl{ margin-right: .24rem; width: .8rem; height: .8rem; text-align: center; background-color: rgba(153,153,153,.14) !important; border-radius: .12rem; }
  .voice-bar span.span01{ background: url("../../assets/a_10.png") no-repeat center; background-size: .54rem .48rem; }
  .voice-bar span.span02{ background: url("../../assets/a_11.png") no-repeat center; background-size: .49rem .49rem; }
  .voice-bar span.span03{margin-right: 0; background: url("../../assets/a_12.png") no-repeat center; background-size: .49rem .49rem; }
  .voice-bar span.span01.curr{ background: url("../../assets/a_10_hov.png") no-repeat center!important; background-size: .54rem .48rem!important; }

  .voice-bar span.zan img{ margin-top: .16rem; height: .48rem; }
  .voice-bar p.fl{ padding: 0 .26rem; width: 70%; height: .8rem; line-height: .8rem; font-weight: bold; font-size: .32rem; color: #f7921e; background-color: #fef4e3; border-radius: .8rem; }
  .voice-bar .fr{ position: absolute; right: .48rem; top: .25rem; width: 2.4rem; height: .8rem; line-height: .8rem; font-size: .36rem; color: #fff; text-align: center; background-color: #ff6422; border-radius: .8rem; }
  .voice-bar .active{ padding-left: .1rem; font-size: .4rem; text-align: left; }
  .voice-bar .active p{ position: absolute; right: .08rem; top: .17rem; width: 1.1rem; line-height: 0; text-align: center; color: #fff; }
  .voice-bar .active p span{ display: block; font-size: .2rem; line-height: .22rem; }
  .voice-bar .active p b{ display: block; font-size: .28rem; line-height: .34rem; text-decoration: line-through; }

  .voice-list-ul{ position: relative;z-index:1; padding: 0 .38rem;overflow-y: scroll;-webkit-overflow-scrolling : touch;-webkit-box-flex: 1; -ms-flex: 1; flex: 1; }
  .voice-scoll{ padding: 1.1rem 0 1rem; width: 100%; height: auto; background: url("../../assets/a_13.png") repeat-y; background-size: 100% auto; }
  .route-box{ position: relative; width: 100%; height: auto; background: url("../../assets/a_18.png") no-repeat top center; background-size: 100% 100%; }
  /*.route-box:after{position: absolute; content: ''; left: 70%; top: 62%; z-index: 1; width: .43rem; height: .7rem; background: url("../../assets/a_20.png") no-repeat center; background-size: 100% 100%; }*/
  .route-li{ position: relative; z-index: 1; text-align: center;  border-radius: 100%; }
  .route-li-name{ padding: .05rem; width: 1.1rem; height: 1.1rem; background-color: rgba(247,146,30,.3); }
  .route-li p.txt{ display: table-cell;width: 1.1rem; height: 1.1rem; font-size: .28rem; color: #fff; vertical-align:middle; background-color: #f7921e; border-radius: 100%; overflow: hidden; }
  .route-li p.name{ position: absolute; left: -10%; top: 1.85rem; width: 120%; font-size: .26rem; color: #231815; text-align: center; }
  .txtlen4{ padding-left: .2rem; padding-right: .2rem; }
  .route-li-img{ padding: .04rem; width: 1.15rem; height: 1.15rem; background-color: #f7921e; }
  .route-li-img p.image{ position: relative; padding: .02rem; width: 1.11rem; height: 1.11rem; background-color: #fff; border-radius: 100%; }
  .route-li-img p.image img{ border-radius: 100%; overflow: hidden; }
  .route-li-img p.image:after{ left: 50%; bottom: -.7rem; z-index: -1; margin-left: -.4rem; width: 0; height: 0; border: .4rem solid; border-color: #f7921e transparent transparent transparent; }
  .route-li-img.curr p.image:before{ top: -.52rem; z-index: -1; margin-left: -.02rem; width: .46rem; height: .54rem; background: url("../../assets/a_16.png") no-repeat center; background-size: 100% 100%; }
  .route-li-img:before,.route-li-img:after,.route-li-img p.image:after,.route-li-img.curr p.image:before{ position: absolute; content: ''; left: 50%; }
  .route-li-img:before{ bottom: -.58rem;z-index: 1; margin-left: -.14rem; width: .28rem; height: .28rem; background-color: #f7921e; border-radius: 100%;  }
  .route-li-img:after{ bottom: -.52rem;z-index: 1; margin-left: -.08rem; width: .16rem; height: .16rem; background-color: #fff; border-radius: 100%;  }

  .route-li-name.route-li-01{ left: -4%; top: -2%;  }
  .route-li-name.route-li-02{  left: 28%; top: -1%; }
  .route-li-name.route-li-03{  left: 64%; top: -8%; }
  .route-li-name.route-li-04{  left: 81%; top: 9%; }
  .route-li-name.route-li-05{  left: 43%; top: 7%; }
  .route-li-name.route-li-06{  left: 5%; top: 2%; }

  .route-li-img.route-li-01{ left: -3%; top: -9%; }
  .route-li-img.route-li-02{  left: 28%; top: -13%; }
  .route-li-img.route-li-03{  left: 64%; top: -21%; }
  .route-li-img.route-li-04{  left: 81%; top: -3%; }
  .route-li-img.route-li-05{  left: 43%; top: -7%; }
  .route-li-img.route-li-06{  left: 5%; top: -13%; }


  .sm.voice-list{ background: #d9cdbf; }
  .sm .voice-list-top{ height: 3.83rem; }
  .sm .voice-bar{ padding: .44rem .48rem; height: 1.68rem; background: #fff url("../../assets/a_17.png") repeat; }
  .sm .voice-bar:before{ left: 0; top: 0; z-index: 1; width: 100%; height: .19rem; border: none; background: url("../../assets/sm-line.png") repeat-x; background-size: auto 100%; }
  .sm .voice-bar:after{ left: 0; right: 0; bottom: 0; z-index: 1; width: 100%; height: .19rem; border: none; background: url("../../assets/sm-line.png") repeat-x; background-size: auto 100%; }
  .sm .voice-bar span.fl{ background-color: rgba(159,136,111,.14) !important; }
  .sm .voice-bar p.fl{ color: #9f886f; background-color: #e6e3e0; }
  .sm .voice-bar .fr{ top: .44rem; background-color: #f7921e; }
  .sm .voice-bar span.span01{ background: url("../../assets/a_10_curr.png") no-repeat center; background-size: .54rem .48rem; }
  .sm .voice-bar span.span02{ background: url("../../assets/a_11_curr.png") no-repeat center; background-size: .49rem .49rem; }
  .sm .voice-bar span.span03{ background: url("../../assets/a_12_curr.png") no-repeat center; background-size: .49rem .49rem; }

  .sm .voice-list-box{ background: #fffbf1 url("../../assets/a_17.png") repeat;}
  .sm .voice-list-top:after,.sm.voice-list:after{ position: absolute; content: ''; z-index: 1; height: .36rem; background: url("../../assets/a_15.png") no-repeat center; background-size: 100% 100%; }
  .sm .voice-list-top:after{ left: -.24rem; right: -.24rem;bottom: -.36rem; }
  .sm.voice-list:after{ left: 0; right: 0; bottom: -.06rem;}
  .sm .voice-scoll{  background: url("../../assets/a_14.png") repeat-y; background-size: 100% auto;}

  .sm .route-box{ background: url("../../assets/a_19.png") no-repeat top center; background-size: 100% 100%; }
  /*.sm .route-box:after{ background: url("../../assets/a_21.png") no-repeat center; background-size: 100% 100%; }*/
  .sm .route-li-name{ background-color: rgba(223,186,143,.3); }
  .sm .route-li p.txt{ background-color: #9f886f; }
  .sm .route-li-img{ background-color: #dfba8f; }
  .sm .route-li-img p.image:after{ border-color: #dfba8f transparent transparent transparent; }
  .sm .route-li-img:before{ background-color: #c1a381; }



</style>



// WEBPACK FOOTER //
// src/page/view-detail/video-list.vue